import './skeleton.scss';

import { FunctionComponent } from "react";

const SkeletonLine : FunctionComponent<{height:string}> = ({height}) => {
    return (
        <div className="skeleton-line" style={{height}}></div>
    )
}

export default SkeletonLine;